// extracted by mini-css-extract-plugin
export default {"title":"About_title__pWrV8","section-box":"About_section-box__sGNi0","introduce-box":"About_introduce-box__KPU2T","introduce-img-box":"About_introduce-img-box__xceWa"};